// extracted by mini-css-extract-plugin
export default {"box_container":"styles_box_container__WbVY0","fab_add":"styles_fab_add__cA5vp","toolbar_container":"styles_toolbar_container__FfDtD"};